export const getRandomColor = () => "#"+((1<<24)*Math.random()|0).toString(16);

const companiesColor = [
	'#DD81A9',
	'#C9C795',
	'#FFBC75',
	'#FFDF83',
	'#BDD697',
	'#C6B099',
	'#5DC194',
	'#6ADAEA',
	'#7B87BC'
];

const statusColor = [
	'#96501E',
	'#B95C1A',
	'#C47F40',
	'#E2813A',
	'#F0A940',
	'#FACF7D'
];

const qualityColor = [
	'#04507A',
	'#0760A1',
	'#2176C4',
	'#3996EB',
	'#3EB3F5',
	'#94D3EE',
	'#043B7A',
	'#073FA1',
	'#2158C4',
	'#3975EB',
	'#3E92F5',
	'#94C0EE',
	'#04177A',
	'#11279A',
	'#2C39AF',
	'#3754EE',
	'#426FE5',
	'#94ADEE',
	'#064568',
	'#10678C',
	'#266898',
	'#308DC1',
	'#3CAFD3',
	'#89B9DB',
	'#74BCC7',
	'#32C7C8',
	'#44B2B2',
	'#32A0AE',
	'#12666B',
	'#048090'
];

export const getColorCompany = (index: number) => {
	if (index >= companiesColor.length ) {
		return getRandomColor();
	}
	return companiesColor[index];
}

export const getColorStatus = (index: number) => {
	if (index >= statusColor.length) {
		return getRandomColor();
	}
	return statusColor[index];
}

export const getColorQuality = (index: number) => {
	if (index >= qualityColor.length) {
		return getRandomColor();
	}
	return qualityColor[index];
}
